// extracted by mini-css-extract-plugin
module.exports = {"selectPerPage":"ChangePerPage_selectPerPage__j0qP2"};